import jwtDecode from 'jwt-decode';

// Matches pm.presence.protocol. This is a one-time login transition, not a
// build version: ordinary deployments must not require another login.
export const LOGIN_VERSION = 1;
export const PRESENCE_CLOSED = 4409;

export function currentLogin(token?: string): boolean {
  if (!token) return false;
  try {
    const login = jwtDecode<{ login_version?: number; presence_id?: string }>(
      token,
    );
    return (
      login.login_version === LOGIN_VERSION &&
      typeof login.presence_id === 'string' &&
      login.presence_id.length === 32
    );
  } catch {
    return false;
  }
}
